import { getLocalizationStringOfTypeService } from 'src/api/common'

const fetchLocalizationStrings = async () => {
  const res = await getLocalizationStringOfTypeService('course-ui')
  return res.data.languages
}

export const settingItemListTypeEnum = {
  STATIC: 0,
  DYNAMIC: 1,
}

export const settingItemTypeEnum = {
  SELECT: 0,
  TEXTFIELD: 1,
}

const data = [
  {
    type: 'language',
    title: 'Language',
    settingItems: [
      {
        description: 'What language should the mini-course be in?',
        key: 'languageCode',
        listFunc: async () => {
          const languages = await fetchLocalizationStrings()
          return languages.map(lang => ({
            name: lang.name,
            value: lang.countryCode,
          }))
        },
        listType: settingItemListTypeEnum.DYNAMIC,
        type: settingItemTypeEnum.SELECT,
        defaultValue: { name: 'English', value: 'en' },
        freeSolo: false,
      },
    ],
  },
  {
    type: 'focus',
    title: 'Specify focus',
    settingItems: [
      {
        description:
          'What part of the source material should the mini-course focus on?',
        key: 'focus',
        type: settingItemTypeEnum.TEXTFIELD,
        list: [],
      },
    ],
  },
  {
    type: 'audience',
    title: 'Audience',
    settingItems: [
      {
        description: 'Who is the mini-course for?',
        key: 'audience',
        type: settingItemTypeEnum.TEXTFIELD,
        list: [],
      },
    ],
  },
  {
    type: 'tone',
    title: 'Tone',
    settingItems: [
      {
        description: 'What tone would you like for the mini-course content?',
        key: 'tone',
        listType: settingItemListTypeEnum.STATIC,
        type: settingItemTypeEnum.SELECT,
        list: [
          { name: 'Analytical', value: 'Analytical' },
          { name: 'Conversational', value: 'Conversational' },
          { name: 'Inspirational', value: 'Inspirational' },
          { name: 'Professional', value: 'Professional' },
          { name: 'Storytelling', value: 'Storytelling' },
          { name: 'Thought-Provoking', value: 'Thought-Provoking' },
          { name: 'Warm', value: 'Warm' },
        ],

        defaultValue: { name: 'Professional', value: 'Professional' },
      },
    ],
  },
  {
    type: 'quiz',
    title: 'Quiz',
    settingItems: [
      {
        description:
          'How many quiz questions should the mini-course include in the end?',
        key: 'finalQuizCount',
        listType: settingItemListTypeEnum.STATIC,
        type: settingItemTypeEnum.SELECT,
        list: [
          { name: '0', value: 0 },
          { name: '1', value: 1 },
          { name: '2', value: 2 },
          { name: '3', value: 3 },
          { name: '4', value: 4 },
          { name: '5', value: 5 },
          { name: '6', value: 6 },
          { name: '7', value: 7 },
          { name: '8', value: 8 },
          { name: '9', value: 9 },
          { name: '10', value: 10 },
          { name: '11', value: 11 },
          { name: '12', value: 12 },
          { name: '13', value: 13 },
          { name: '14', value: 14 },
          { name: '15', value: 15 },
        ],
        defaultValue: { name: '5', value: 5 },
      },
    ],
  },
  {
    type: 'feedback',
    title: 'Feedback Questions',
    settingItems: [
      {
        description:
          'How many feedback questions should the mini-course include in the end?',
        key: 'finalSurveyCount',
        listType: settingItemListTypeEnum.STATIC,
        type: settingItemTypeEnum.SELECT,
        list: [
          { name: '0', value: 0 },
          { name: '1', value: 1 },
          { name: '2', value: 2 },
          { name: '3', value: 3 },
          { name: '4', value: 4 },
          { name: '5', value: 5 },
          { name: '6', value: 6 },
          { name: '7', value: 7 },
          { name: '8', value: 8 },
          { name: '9', value: 9 },
          { name: '10', value: 10 },
        ],

        defaultValue: { name: '1', value: 1 },
      },
    ],
  },

  {
    type: 'imageSettings',
    title: 'AI Images',
    settingItems: [
      {
        description: 'Would you like to add AI-generated images?',
        key: 'generateImage',
        freeSolo: false,
        listType: settingItemListTypeEnum.STATIC,
        type: settingItemTypeEnum.SELECT,
        removeItems: ['imageStyle', 'imageCharacter'],
        list: [
          {
            name: 'Yes',
            value: true,
            addItems: ['imageStyle', 'imageCharacter'],
          },
          {
            name: "I don't want",
            value: false,
            removeItems: ['imageStyle', 'imageCharacter'],
          },
        ],
        defaultValue: { name: 'Yes', value: true },
      },
      {
        description: 'How should be the image style?',
        key: 'imageStyle',
        listType: settingItemListTypeEnum.STATIC,
        type: settingItemTypeEnum.SELECT,
        list: [
          { name: 'Bokeh', value: 'Bokeh' },
          { name: 'Cinematic', value: 'Cinematic' },
          { name: 'Cartoon', value: 'Cartoon' },
          { name: 'Illustration', value: 'Illustration' },
          { name: 'Isometric', value: 'Isometric' },
          { name: 'Minimalist', value: 'Minimalist' },
          { name: 'Realistic photography', value: 'Realistic photography' },
          { name: 'Simple line art', value: 'Simple line art' },
          { name: 'Watercolor', value: 'Watercolor' },
        ],
        defaultValue: { name: 'Cinematic', value: 'Cinematic' },
      },
      {
        description:
          'Describe the individuals in the images to match their demographics to your topic.',
        key: 'imageCharacter',
        listType: settingItemListTypeEnum.STATIC,
        type: settingItemTypeEnum.TEXTFIELD,
        list: [],

        defaultValue: {
          name: 'The individuals should include a mix of ages.',
          value: 'The individuals should include a mix of ages.',
        },
      },
    ],
  },
  {
    type: 'relevance',
    title: 'Relevance',
    settingItems: [
      {
        description: 'How should AI use your source?',
        key: 'relevance',
        listType: settingItemListTypeEnum.STATIC,
        type: settingItemTypeEnum.SELECT,
        list: [
          { name: 'Stay within my source', value: 'strict' },
          { name: 'Build upon my source', value: 'expanded' },
         
        ],

        defaultValue: { name: 'Stay within my source', value: 'strict' },
      },
    ],
  },
]
export default data
